const state = {
  service_id: [],
};

export default state;
